import { ContestApi } from 'api-typings/contests/contests';
import { transformContest } from '../contests/contests.transformers';
import { SearchActiveContestsEntry } from './search-active-contests.model';

export function transformSearchActiveContest(
  contest: ContestApi,
): SearchActiveContestsEntry {
  if (!contest.jobs) {
    throw new ReferenceError(`Missing a required contest entry field.`);
  }
  return {
    ...transformContest(contest),
    skillIds: contest.jobs.map(job => job.id),
  };
}
